<template>
  <div v-if="extensionProduct">
    <transition name="f-fade">
      <div v-if="showExtendCard" class="bg-gray-100 border border-gray-300 rounded-md p-4">
        <h2 class="font-semibold text-center">Not Ready Yet?</h2>
        <p class="mb-4">Add <strong>{{DIGITIZATION_PROJECT_EXPIRY_PERIOD}} Additional Days</strong> for only <span><strong><core-price-display :base-price="project.products.extension.price_cents" :discounted-price="project.products.extension.promotionPrice" /></strong></span>.</p>
        <u-button
          color="charcoal"
          label="Buy"
          class="min-w-20 justify-center"
          @click="addToCart"
          :loading="isAddingToCart"
        />
      </div>
      <p v-else><strong>Not Ready Yet? No Problem!</strong> <a href="#" @click.prevent="showExtendCard = true">Add more time</a> to help you decide.</p>
    </transition>
  </div>
</template>

<script setup>
  const props = defineProps({
    showExpanded: {
      type: Boolean,
      default: false
    },
    project: Object,
    upsellTracking: Object
  });

  const showExtendCard = ref(props.showExpanded);
  const extensionProduct = computed(() => props.project.products?.extension);

  const isAddingToCart = ref(false);
  async function addToCart() {
    if (isAddingToCart.value) return;

    isAddingToCart.value = true;
    try {
      trackUpsellCta({
        tracking: props.upsellTracking,
        product: extensionProduct.value
      });

      await useDigitizationApiService().addDigiProjectStorageToCart({
        product: extensionProduct.value,
        projectId: props.project.id
      });
      window.location = EXTERNAL_URLS.cart;
    } catch {
      useErrorToast().add('Unable to add to cart at this time. Please try again later.');
    } finally {
      isAddingToCart.value = false;
    }
  }
</script>
